import { Anchor, List, Title } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import api from "../services/api";
import './index.less';
import logo from '../images/logo.svg';
import logoInverse from '../images/logo-inverse.svg';
import beian from '../images/beian.png';
import { Link } from 'gatsby';

const initialLinks = [
  { link: '/', name: '公司介绍' },
  {
    name: '现场化学品生产', children: [
      { link: '/product', name: '双氧水现场生产技术', value: 0 },
      { link: '/partner', name: '双氧水工厂伙伴', value: 1 },
    ]
  },
  { link: '/cases', name: '应用与案例' },
  { key: 'news', link: '/news', name: '新闻资讯', children: [] },
  { link: '/about', name: '联系我们' },
];

const footerLinks = [
  { link: '/', name: '公司介绍' },
  { link: '/#p2x', name: 'P2X理念' },
  { link: '/product', name: '现场化学品生产' },
  { link: '/product#tech', name: '储能技术' },
  { link: '/partner', name: '双氧水伙伴工厂' },
  { link: '/cases', name: '应用与案例' },
  { link: '/news', name: '新闻资讯' },
  { link: '/cases#download', name: '下载资料' },
  { link: '/about', name: '联系我们' },
];

function Layout({ location, children }: { children: React.ReactNode, location: any }) {
  const [links, setLinks] = useState(initialLinks);

  const fetchNewsTypeList = async () => {
    try {
      const response = await api.post('/api/app/dict/info/data', {
        types: 'articleType'
      });
      const typeData = response.data.data.articleType;
      const newLinks = [...initialLinks];
      const newsIndex = newLinks.findIndex(item => item.key === 'news');
      newLinks[newsIndex] = {
        name: newLinks[newsIndex].name,
        children: typeData.map((item: { id: any; name: any; }) => ({
          link: `/news?type=${item.id}`, 
          name: item.name
        }))
      };

      setLinks(newLinks);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchNewsTypeList();
  }, []);

  const currentPath = '/' + location.pathname.split('/')[1] + location.search;

  return (<>
    <header>
      <div className="logo-container">
        <img className="logo" src={logo} />
      </div>
      <nav>
        <div className="links-container">
          {links.map((item, index) => (item.link ?
            <Link
              key={item.link}
              className={currentPath === item.link ? 'active' : ''}
              to={item.link || ''}
            >
              {item.name}
            </Link>
            : <a
              key={item.link}
              className="menu"
              style={{zIndex: 100 - index}}
            >
              {item.name}
              {item.children && (<div className='children'>
                {item.children.map(subItem => (
                  <Link
                    key={subItem.link}
                    className={currentPath === subItem.link ? 'active' : ''}
                    to={subItem.link || ''}
                  >{subItem.name}</Link>
                ))}
              </div>)}
            </a>
          ))}
        </div>
      </nav>
    </header>
    <main>
      {children}
    </main>
    <footer>
      <div className="container">
        <div className="company">
          <div className="logo-container">
            <img className="logo" src={logoInverse} />
          </div>
          <p className="intro">橙氧科技是一家专注于电化学领域的硬科技企业。橙氧科技的目标和愿景是使用基于公司领先的新型流体扩散电极的高效电化学反应系统，将其应用于双碳背景下的可再生电力多元转化（Power-to-X）领域，特别是大宗化学品生产（Power-to-Chemicals）的细分行业，用创新技术市场化的解决传统化工行业的巨大减排压力。</p>
        </div>
        <div className="links">
          <Title className='title' order={2}>快速链接</Title>
          <List>
            {footerLinks.map(item => (<Anchor
              key={item.link}
              href={item.link}
            >{item.name}</Anchor>))}
          </List>
        </div>
        <div className="contract">
          <Title className="title" order={2}>联系我们</Title>
          <span>info@chengyangtech.com</span>
          <span>0575-85599858</span>
          <span>021-60560385</span>
          <span>上海市宝山区长江路555号</span>
        </div>
      </div>
      <div className="copyright">
        <div>
          <span>版权所有 &copy; {(new Date()).getFullYear()}</span>
          <span>上海橙氧科技有限公司</span>
          <Link to="/privacy">隐私条款</Link>
        </div>
        <div className='beian'>
          <Anchor href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33060302000783" target="_blank">
            <img src={beian} /> 浙公安网备33060302000783号
          </Anchor>
          <Anchor href="http://beian.miit.gov.cn/" target="_blank">浙ICP备20022661号</Anchor>
        </div>
      </div>
    </footer>
  </>);
}

export default Layout;
